module.exports = __webpack_public_path__ + "img/wti-banner.7d4396ab.jpg";